import { Controller, useFormContext } from 'react-hook-form';
import { Input, PhoneInput } from '@ds';
import { BaseSupplementalLiftAviaSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useLegFormContext } from '@lp/features/RoutePlanner/components/RouteLegForm/context/LegFormContext';
import { useWatchFields } from '@/hooks/useWatchFields';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

export const NonTmdxCrewMembersInputs = () => {
  const { isOptionalDataEdit } = useLegFormContext();
  const { control } = useFormContext<BaseSupplementalLiftAviaSchemaValues>();
  const { countryCodes } = useCountriesData();
  const { crewMembers } = useWatchFields<BaseSupplementalLiftAviaSchemaValues>(['crewMembers'] as const);

  return crewMembers.map((_, index) => {
    const memberCountNumber = index + 1;

    return (
      <div key={memberCountNumber} className="flex flex-row gap-6">
        <div className="flex min-w-[55%] gap-6">
          <Controller
            name={`crewMembers.${index}.firstName`}
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <Input
                aria-label="Crew member first name"
                label="Crew member first name"
                placeholder="Crew member first name"
                isInvalid={invalid}
                isDisabled={!isOptionalDataEdit}
                {...field}
              />
            )}
          />
          <Controller
            name={`crewMembers.${index}.lastName`}
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <Input
                aria-label="Crew member last name"
                label="Crew member last name"
                placeholder="Crew member last name"
                isInvalid={invalid}
                isDisabled={!isOptionalDataEdit}
                {...field}
              />
            )}
          />
        </div>
        <div className="h-auto w-full">
          <Controller
            name={`crewMembers.${index}.phoneNumber`}
            control={control}
            render={({ field, fieldState: { invalid, isTouched } }) => (
              <PhoneInput
                countries={countryCodes}
                aria-label="Crew member phone number"
                label="Crew member phone number"
                placeholder="Crew member phone number"
                isInvalid={invalid && isTouched}
                disabled={!isOptionalDataEdit}
                selectLabel="Code"
                selectAriaLabel="Phone code input"
                inputAriaLabel="Phone number input"
                {...field}
              />
            )}
          />
        </div>
      </div>
    );
  });
};
